import { Injectable } from '@angular/core';
import { HistoricalPaymentInfo } from '@pdqdev/pdq-shared/dist/entities';
import { ExtensionsService } from '@app/pages/checkout-app/services/extensions/extensions.service';
import { Subscription } from 'rxjs';

@Injectable()
export class HistoricalPaymentService {
  data: HistoricalPaymentInfo | null = null;
  private loadSubscription: Subscription | null = null;

  constructor(private extensionsService: ExtensionsService) {}

  get isInProgress(): boolean {
    return !!this.data && this.data.inProgress && this.data.endedAt === null;
  }

  get isCompleted(): boolean {
    return !!this.data && !this.data.inProgress && this.data.startedAt !== null && this.data.endedAt !== null;
  }

  get subtext(): string | null {
    if (this.isInProgress) {
      return 'We are pulling historical payment info data, this would take some time.';
    }
    if (this.isCompleted) {
      return 'Historical payment info data has been successfully pulled.';
    }
    if (!this.data) {
      return 'This will pull the last 365 days of historical payment info data.';
    }
    return null;
  }

  get tooltip(): string | null {
    if (this.isInProgress) {
      return 'Cannot turn off while historical payment info data pulling is in progress';
    }
    if (this.isCompleted) {
      return 'Historical payment info data has already been pulled';
    }
    return null;
  }

  get isToggleLocked(): boolean {
    return this.isInProgress || this.isCompleted;
  }

  load(onSuccess?: (data: HistoricalPaymentInfo | null) => void): void {
    this.loadSubscription = this.extensionsService.getHistoricalPaymentInfo().subscribe({
      next: (response) => {
        this.data = response ?? null;
        onSuccess?.(this.data);
      },
      error: () => {
        this.extensionsService.createToast({
          message: 'Failed to load historical payment info',
          mode: 'danger',
        });
      },
    });
  }

  destroy(): void {
    this.loadSubscription?.unsubscribe();
  }
}
